import { isRouteErrorResponse, Link, useRouteError } from 'react-router';

/** Shown when a page fails to render or a code chunk cannot be loaded (e.g. right after a deploy). */
export function RouteError() {
  const error = useRouteError();
  const chunkFailed = error instanceof Error && /dynamically imported module|Importing a module script failed|Failed to fetch/i.test(error.message);
  const title = isRouteErrorResponse(error) && error.status === 404 ? 'This page does not exist' : 'Something went wrong';
  const body = chunkFailed
    ? 'A new version of Cryptohopper Charts was just published. Reload to get it.'
    : 'The page hit an unexpected error. Reloading usually fixes it; your layouts and settings are kept.';
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center bg-ink px-6 text-center">
      <h1 className="text-2xl font-semibold text-fg">{title}</h1>
      <p className="mt-2 max-w-md text-fg-2">{body}</p>
      <div className="mt-6 flex gap-3">
        <button type="button" onClick={() => window.location.reload()} className="rounded-md bg-accent px-4 py-2 font-semibold text-accent-fg">
          Reload
        </button>
        <Link to="/" className="rounded-md border border-line-strong px-4 py-2 text-fg-2 hover:bg-hover hover:text-fg">
          Go home
        </Link>
      </div>
    </div>
  );
}
